import { render, staticRenderFns } from "./FeaturedArticlesGroupBlock.vue?vue&type=template&id=5978d2e1&scoped=true&"
import script from "./FeaturedArticlesGroupBlock.vue?vue&type=script&lang=js&"
export * from "./FeaturedArticlesGroupBlock.vue?vue&type=script&lang=js&"
import style0 from "./FeaturedArticlesGroupBlock.vue?vue&type=style&index=0&id=5978d2e1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5978d2e1",
  null
  
)

export default component.exports